import Image from "./modules/image/Image.js";
import RotationControls from "./modules/image/RotationControls.js";
import ZoomControls from "./modules/image/ZoomControls.js";
import ImageFooter from "./modules/image/ImageFooter.js";
import Sequence from "./modules/image/Sequence.js";
import Overlay from "./modules/image/overlays/Overlay.js";
import OverlayGroup from "./modules/image/overlays/OverlayGroup.js";
import CoordinateConversion from "./modules/image/tools/CoordinateConversion.js";
import AreaSelect from "./modules/image/drawing/AreaSelect.js";
import Transform from "./modules/image/drawing/Transform.js";
import Draw from "./modules/image/drawing/Draw.js";
import ViewPersistence from "./modules/image/ViewPersistence.js";
import Tooltip from "./modules/image/overlays/Tooltip.js";
import * as ImageFilters from "./modules/image/DrawFilter.js";
import DataPoint from "./modules/image/dataPoint/imageView.dataPoint.js";
import DataPointTransform from "./modules/image/dataPoint/imageView.dataPoint.transform.js";
import ColorIterator from "./modules/image/tools/ColorIterator.js";

window.ImageView = {
    Image : Image,
    Controls: {
        Rotation: RotationControls,
        Zoom: ZoomControls,
    },
    DataPoint: {
        Point: DataPoint,
        Transform: DataPointTransform
    },
    ViewPersistence: ViewPersistence,
    Footer: ImageFooter,
    Sequence: Sequence,
    Overlay: Overlay,
    OverlayGroup: OverlayGroup,
    Tooltip: Tooltip,
    AreaSelect: AreaSelect,
    CoordinateConversion: CoordinateConversion,
    ColorIterator: ColorIterator,
    ImageFilters: ImageFilters,
    Transform : Transform,
    Draw : Draw
}